import { render, staticRenderFns } from "./GatewayLampsInsert.vue?vue&type=template&id=4283e013&"
import script from "./GatewayLampsInsert.vue?vue&type=script&lang=js&"
export * from "./GatewayLampsInsert.vue?vue&type=script&lang=js&"
import style0 from "./GatewayLampsInsert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports